module.exports = __webpack_public_path__ + "static/media/icon_Survey2_W.870475a2.svg";